<template>
  <div v-if="success" class="success">
    <h1>{{ __('Lyckades!') }}</h1>
    <p class="margin-bottom-x2">{{ __('Din månadsplan  har ändrats') }}.</p>
    <button class="button" @click="() => this.$router.push('/')">
      {{ __('Tillbaka') }}
    </button>
  </div>
  <div v-else-if="step === 1">
    <h1>{{ __('Ändra plan') }}</h1>
    <choose-subscription v-model="selectedSubscriptionId" :productId="currentProductId" :next="() => step++">
      <div class="fix-width text-small margin-bottom-x3">
        {{
          __(
            'För att kunna kommunicera med din sensor måste du välja ett abonnemang. Läs mer om Equardians olika'
          )
        }}
        <a href="https://equardian.com/abonnemang/" target="_blank">{{ __('abonnemang') }}</a
        >.
      </div>
      <div class="row">
        <button class="button button-snd" @click="() => $router.go(-1)">
          {{ __('Tillbaka') }}
        </button>

        <button
          class="button desktop"
          @click="() => step++"
          :disabled="!selectedSubscriptionId && selectedSubscriptionId !== 0"
        >
          {{ __('Fortsätt') }}
        </button>
      </div>
    </choose-subscription>
  </div>
  <div v-else>
    <h1>{{ __('Ange betalningsinfo') }}</h1>
    <payment :next="() => this.updateSubscription()">
      <div class="fix-width text-small margin-bottom-x3">
        {{
          __(
            'Välj någon av ovan alternativ för att gå vidare. Medlemskapet börjar så fort du har angett din betalningsinformation'
          )
        }}.
      </div>
    </payment>
  </div>
</template>
<script>
export default {
  data () {
    return {
      selectedSubscriptionId: null,
      step: 1,
      success: false,
    }
  },
  components: {
    ChooseSubscription: () => import('@/components/ChooseSubscription.vue'),
    Payment: () => import('@/components/Payment.vue'),
  },
  computed: {
    currentProductId () {
      return this.$store.getters.currentProductId
    },
  },
  methods: {
    updateSubscription () {
      this.$store.commit('setSubscriptionId', this.selectedSubscriptionId)
      this.success = true
    },
  },
}
</script>
<style lang="less">
@import '../../style/variables.less';
</style>
